
export { EasyNgxGoogleAnalyticsModule } from './src/easy-ngx-google-analytics.module';
export { EasyAnalyticsConfig } from './src/easy-analytics.config';